import type { AudioAnnotationSingleSelectField } from '@/features/nectar/api/models'
import { clsx } from 'clsx'
import { FieldLabel } from '../FieldLabel'

type SingleSelectFieldProps = {
  field: AudioAnnotationSingleSelectField
  value: string | undefined
  onChange: (value: string) => void
  fieldsClassName?: string
}

export const SingleSelectField = ({ field, value, onChange, fieldsClassName }: SingleSelectFieldProps) => (
  <div className="flex flex-col gap-3">
    <FieldLabel label={field.label} description={field.description} required={field.required} />
    <div className={clsx('flex flex-wrap gap-2', fieldsClassName)}>
      {field.options.map((option) => {
        const selected = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={clsx(
              'flex h-10 min-w-[88px] flex-1 cursor-pointer items-center justify-center rounded-lg border border-solid p-3 text-center text-sm font-semibold transition-colors',
              selected ? 'border-green bg-green/5 text-green' : 'text-gray-70 hover:border-gray-90 border-gray-100'
            )}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  </div>
)
